module.exports = __webpack_public_path__ + "img/banner1.bee783f9.png";